// Navigation actions
import * as types from './actionTypes';

export const hasSideBar = (sideBar) => {
    return {
        type: types.NAVIGATION_HAS_SIDEBAR,
        hasSideBar: sideBar,
    };
};

export const toggleSideBar = (toggle) => {
    return {
        type: types.NAVIGATION_TOGGLE_SIDEBAR,
        open: toggle,
    };
};

export const updateCurrentComponent = (componentName) => {
    return {
        type: types.NAVIGATION_UPDATE_COMP_NAME,
        componentName: componentName,
    };
};
export const setCurrentRuleId = (currentRuleId) => {
    return {
        type: types.CURRENT_RULE_ID,
        currentRuleId: currentRuleId,
    };
};
export const setCurrentRuleName = (currentRuleName) => {
    return {
        type: types.CURRENT_RULE_NAME,
        currentRuleName: currentRuleName,
    };
};

export const setGroupDetails = (groupDetails) => {
    return {
        type: types.GROUP_DETAILS,
        groupDetails: groupDetails,
    };
};

